import {TableSummary} from '../../../../../domain/out/table-summary';
import {CustomGroup} from '../../../../../domain/in/quote/group/custom-group';
import {TranslationServiceInterface} from '../../../../translation-service.interface';
import {AbstractPricingItemSummaryMapper} from '../abstract-pricing-item-summary.mapper';
import {FrDiscoSasSynthesisMapper} from './sas/fr.disco.sas.synthesis.mapper';
import {FrDiscoCafSynthesisMapper} from './caf/fr.disco.caf.synthesis.mapper';
import {FrDiscoSolSynthesisMapper} from './sol/fr.disco.sol.synthesis.mapper';
import {FrDiscoVtSynthesisMapper} from './vt/fr.disco.vt.synthesis.mapper';
import {FrDiscoLsSynthesisMapper} from './ls/fr.disco.ls.synthesis.mapper';
import {FrDiscoFonSynthesisMapper} from './fon/fr.disco.fon.synthesis.mapper';
import {FrDiscoThreeDSynthesisMapper} from './three_d/fr.disco.three_d.synthesis.mapper';
import {FrDiscoDasriSynthesisMapper} from './dasri/fr.disco.dasri.synthesis.mapper';

export class TableSummaryDiscoMapper {
    private readonly mappers: Map<string, AbstractPricingItemSummaryMapper>;

    constructor(protected translationService: TranslationServiceInterface) {
        this.mappers = new Map<string, AbstractPricingItemSummaryMapper>([
            ['SAS', new FrDiscoSasSynthesisMapper(translationService)],
            ['FON', new FrDiscoFonSynthesisMapper(translationService)],
            ['CAF', new FrDiscoCafSynthesisMapper(translationService)],
            ['SOL', new FrDiscoSolSynthesisMapper(translationService)],
            ['VT', new FrDiscoVtSynthesisMapper(translationService)],
            ['LS', new FrDiscoLsSynthesisMapper(translationService)],
            ['3D', new FrDiscoThreeDSynthesisMapper(translationService)],
            ['DASRI', new FrDiscoDasriSynthesisMapper(translationService)],
        ]);
    }

    public async getTablesSummary(group: CustomGroup, serviceCode: string, currency: string, view: string, locale: string): Promise<TableSummary[]> {
        const tableSummaries: TableSummary[] = [];
        const pricingItems = group.pricingItems ? group.pricingItems.filter(pricingItem => pricingItem.userInputs?.quantity !== 0) : [];
        const mapper = this.mappers.get(serviceCode);
        if (mapper) {
            const tableSummary = new TableSummary();
            tableSummary.pricingItems = await Promise.all(pricingItems.map(pricingItem =>
                mapper.pricingItemToProductItemSummary(pricingItem, currency, locale)
            ));
            tableSummaries.push(tableSummary);
        }
        return tableSummaries;
    }

}